import study from "./study";
import social from "./social";

/**
 * 华博特项目接口文档
 */
export default {
  study,
  social,
};
